"use strict";

/*!
 * Name: StGeorges JS
 * Author: Zengenti Ltd
 * Author URI: http://zengenti.com
 * Description: St George's University
 * Version: 0.0.3
 */
var app = function ($) {
  "use strict";

  // private alias to settings

  var s;

  return {
    settings: function settings() {
      this.$window = $(window);
      this.$mediaMatchMed = window.matchMedia("(max-width: 1023px)");
      this.$menuToggle = $(".menu-toggle");
      this.$searchToggle = $(".search-toggle");
      this.$accordion = $(".accordion");
      this.$bannerCarousel = $(".banner__carousel");
      this.$carouselPauseBtn = $("#bc__pause");
      this.$cardsSlider = $(".cards-slider");
      this.$featureSlider = $(".feature-slider");
      this.$tabs = $(".tabs-panel");
      this.$pageTabs = $(".page-tabs");
      this.$pageTabLinks = $(".pt__n__link");
      this.$pageTabTabs = $(".pt__tab");
      this.$spViewer = $(".sp__viewer");
      this.$profileCard = $(".profile-card--sticky");
      this.$ptNavToggle = $(".pt__nav-toggle");
      this.$imageGallery = $(".image-gallery");
      this.$testimonialSlider = $(".testimonial-slider");
      this.$hunter = $(".hunter-widget");
      this.$adfs = $(".js-wsfed-login");
      this.$focusTraps = $(".navs");
    },

    init: function init() {
      s = new this.settings();

      if (s.$adfs.length) {
        this.autoLogin();
      }
      if (typeof history !== "undefined") {
        this.clearADFSHash();
      }

      this.svgCache();
      this.headerToggles();
      this.accordion();
      this.offScreenPanelKeyControl();
      this.focusTrap();

      if (s.$bannerCarousel.length) {
        this.bannerCarouselControl();
      }
      if (s.$cardsSlider.length) {
        this.cardsSliderControl();
      }
      if (s.$featureSlider.length) {
        this.featureSliderControl();
      }
      if (s.$spViewer.length) {
        this.spViewerControl();
      }
      if (s.$tabs.length) {
        this.tabsInit();
      }
      if (s.$pageTabs.length) {
        this.pageTabsInit();
        this.mobilePageTabsDropdown();
      }
      if (s.$imageGallery.length) {
        this.imageGalleryInit();
      }
      if (s.$testimonialSlider.length) {
        this.testimonialSliderInit();
      }
      if (s.$hunter.length) {
        this.hunterWidget();
      }

      this.initStickyProfile();

      this.bindUIActions(); // UI Actions (click, focus etc)
      this.bindWindowActions(); // Window actions (scrolling, resize etc)
    },

    svgCache: function svgCache() {
      (function (window, document) {
        "use strict";

        var file = "/site-elements/images/svg.html",
            revision = 76523;

        if (!document.createElementNS || !document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect) return true;

        var isLocalStorage = "localStorage" in window && window["localStorage"] !== null,
            request,
            data,
            insertIT = function insertIT() {
          document.body.insertAdjacentHTML("afterbegin", data);
        },
            insert = function insert() {
          if (document.body) insertIT();else document.addEventListener("DOMContentLoaded", insertIT);
        };

        if (isLocalStorage && localStorage.getItem("inlineSVGrev") == revision) {
          data = localStorage.getItem("inlineSVGdata");
          if (data) {
            insert();
            return true;
          }
        }

        try {
          request = new XMLHttpRequest();
          request.open("GET", file, true);
          request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
              data = request.responseText;
              insert();
              if (isLocalStorage) {
                localStorage.setItem("inlineSVGdata", data);
                localStorage.setItem("inlineSVGrev", revision);
              }
            }
          };
          request.send();
        } catch (e) {
          // comment
        }
      })(window, document);

      // PNG Fallback
      (function (window, document) {
        if (document.createElementNS && document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect) return true;
        var uses = document.getElementsByTagName("use"),
            use;
        while (use = uses[0]) {
          var svg = use.parentNode,
              img = new Image();
          img.src = use.getAttribute("data-img");
          svg.parentNode.replaceChild(img, svg);
        }
      })(window, document);
    },

    headerToggles: function headerToggles() {
      s.$menuToggle.on("click", function (e) {
        e.preventDefault();
        $(".nav--main").toggleClass("nav--open");

        $(this).toggleClass("toggled");
        $(".search-query").removeClass("search-query--open");
        s.$searchToggle.removeClass("toggled");
        $("body").toggleClass("noscroll");
        $(this).parent().prev().find(".nav__item").children("button").get(0).focus();
      });
      s.$searchToggle.on("click", function (e) {
        e.preventDefault();
        $(".search-query").toggleClass("search-query--open");

        $(this).toggleClass("toggled");
        if ($(this).hasClass("toggled")) {
          window.trapList[0].activate();
        } else {
          window.trapList[0].deactivate();
        }
        $(this).next(".live-search-listing").find("#searchQueryControl").get(0).focus();
      });
      $(".search-toggle.toggled").on("click", function (e) {
        e.preventDefault();
        $(".search-query").toggleClass("search-query--open");
        s.$searchToggle.toggleClass("toggled");
        $(this).parent(".search-query").prev(".search-toggle").get(0).focus();
      });
    },

    accordion: function accordion() {
      s.$accordion.find(".accordion__heading").each(function () {
        var $this = $(this);
        var $panel = $this.next();
        var id = "collapsible-" + $this.index();
        var ariaHidden = $this.hasClass("accordion__heading--open") ? false : true;
        var ariaExpanded = $this.hasClass("accordion__heading--open") ? true : false;

        // add aria attributes
        $panel.attr("id", id).attr("aria-hidden", ariaHidden);
        $this.find("a").attr({
          "aria-expanded": ariaExpanded,
          "aria-controls": id
        });

        // toggle the state properties
        $this.children(".accordion__heading a").on("click", function (e) {
          e.preventDefault();

          var $this = $(this);
          var state = $this.attr("aria-expanded") === "false" ? true : false;

          $this.parent().toggleClass("accordion__heading--open");
          $this.attr("aria-expanded", state);
          $panel.attr("aria-hidden", !state);
        });
      });

      //open all
      s.$accordion.children(".view-all").on("click", function (e) {
        e.preventDefault();
        $(this).removeClass("closed");
        $(this).next(".close-all").addClass("opened");
        $(this).siblings(".accordion__heading").addClass("accordion__heading--open");
        s.$accordion.find(".accordion__heading").each(function () {
          var $this = $(this);
          var $panel = $this.next();
          var id = "collapsible-" + $this.index();
          var ariaHidden = $this.hasClass("accordion__heading--open") ? false : true;
          var ariaExpanded = $this.hasClass("accordion__heading--open") ? true : false;

          // add aria attributes
          $panel.attr("id", id).attr("aria-hidden", ariaHidden);
          $this.find("a").attr({
            "aria-expanded": ariaExpanded,
            "aria-controls": id
          });
        });
      });
      //close all
      s.$accordion.children(".close-all").on("click", function (e) {
        e.preventDefault();
        $(this).removeClass("opened");
        $(this).prev(".view-all").addClass("closed");
        $(this).siblings(".accordion__heading").removeClass("accordion__heading--open");
        s.$accordion.find(".accordion__heading").each(function () {
          var $this = $(this);
          var $panel = $this.next();
          var id = "collapsible-" + $this.index();
          var ariaHidden = $this.hasClass("accordion__heading--open") ? false : true;
          var ariaExpanded = $this.hasClass("accordion__heading--open") ? true : false;

          // add aria attributes
          $panel.attr("id", id).attr("aria-hidden", ariaHidden);
          $this.find("a").attr({
            "aria-expanded": ariaExpanded,
            "aria-controls": id
          });
        });
      });
    },

    offScreenPanelKeyControl: function offScreenPanelKeyControl() {
      $(".offscreen-panel .sys_form-submit").blur(function () {
        var activePanel = $(this).closest(".offscreen-panel.active");
        var activePanelClose = activePanel.children(".offscreen-panel__close");
        activePanelClose.focus();
      });
    },

    bannerCarouselControl: function bannerCarouselControl() {
      var isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)) ? true : false;
      var autoplayState = true;
      if (s.$bannerCarousel.hasClass("bc--no-autoplay")) {
        autoplayState = false;
      }

      var vidId = "";

      s.$bannerCarousel.on("init", function () {
        var $video = s.$bannerCarousel.find("video");
        var bannerSlide = $(".banner__slide.bs--video");

        if (isMobile) {
          var vidSlide;
          $.each(bannerSlide, function (item) {
            vidSlide = $(bannerSlide[item]);
            vidId = vidSlide.data("vidId");
            $(vidId).remove();
          });
        }

        if ($video.length && !isMobile) {
          var currSlide = $(".slick-current");
          if (currSlide.hasClass("bs--video")) {
            vidId = currSlide.data("vidId");
            $(vidId).get(0).play();
          }

          $.each(bannerSlide, function (item) {
            vidSlide = $(bannerSlide[item]);
            vidId = vidSlide.data("vidId");
            $(vidId).closest(".banner__slide").css("background-image", "");
          });
        }
      });

      s.$bannerCarousel.slick({
        slide: ".banner__slide",
        autoplay: autoplayState,
        speed: 1000,
        duration: 30,
        fade: true,
        draggable: false,
        accessibility: true,
        rows: 0,
        nextArrow: "#bc__next",
        prevArrow: "#bc__prev",
        autoplaySpeed: 8000
      });

      s.$bannerCarousel.on("beforeChange", function () {
        var $video = s.$bannerCarousel.find("video");

        if ($video.length && !isMobile) {
          var currSlide = $(".slick-current");
          if (currSlide.hasClass("bs--video")) {
            vidId = currSlide.data("vidId");
          } else {
            vidId = "";
          }
        }
      });

      s.$bannerCarousel.on("afterChange", function () {
        var $video = s.$bannerCarousel.find("video");

        if ($video.length && !isMobile) {
          $video.get(0).pause();
          var currSlide = $(".slick-current");
          if (vidId != "") {
            $(vidId)[0].currentTime = 0;
          }
          if (!s.$carouselPauseBtn.hasClass("paused")) {
            if (currSlide.hasClass("bs--video")) {
              vidId = currSlide.data("vidId");
              $(vidId).get(0).play();
            }
          } else {
            if (currSlide.hasClass("bs--video")) {
              vidId = currSlide.data("vidId");
              $(vidId).get(0).pause();
            }
          }
        }
      });

      $("#bc__prev, #bc__next").on("click", function () {
        // s.$carouselPauseBtn.addClass('paused');
        // s.$bannerCarousel.slick('slickPause');
        var currSlide = $(".slick-current");

        if (!s.$carouselPauseBtn.hasClass("paused")) {
          if (currSlide.hasClass("bs--video")) {
            var vidId = currSlide.data("vidId");
            $(vidId).get(0).play();
          }
        } else {
          if (currSlide.hasClass("bs--video")) {
            vidId = currSlide.data("vidId");
            $(vidId).get(0).pause();
          }
        }
      });

      s.$carouselPauseBtn.on("click", function (e) {
        var $this = $(this);
        var slider = $this.closest(".slick-slider");
        var currSlide = $(".slick-current");
        var vidId;
        if (!$this.hasClass("paused")) {
          $this.addClass("paused");
          slider.slick("slickPause");
          if (currSlide.hasClass("bs--video")) {
            vidId = currSlide.data("vidId");
            $(vidId).get(0).pause();
          }
        } else {
          $this.removeClass("paused");
          slider.slick("slickPlay");
          if (currSlide.hasClass("bs--video")) {
            vidId = currSlide.data("vidId");
            $(vidId).get(0).play();
          }
        }
        e.preventDefault();
      });
    },

    hunterWidget: function hunterWidget() {
      var baseUrl = function baseUrl(queryTerm, queryResource) {
        return "https://sgul-primo.hosted.exlibrisgroup.com/primo-explore/search?institution=44SGUL&vid=44SGUL_VU1&mode=Basic&bulkSize=10&displayMode=full&highlight=true&dum=true&query=any,contains," + queryTerm + "&displayField=all&search_scope=" + queryResource + "&lang=en_US";
      };

      var getHunterParams = function getHunterParams() {
        var term = $(".hunter-widget #hunterControlInput").val();
        var resource = $(".hunter-widget #hunterControlDropdown").val();
        return [term, resource];
      };

      $("#hunterControlSubmit").on("click", function () {
        var query = getHunterParams();
        window.location.href = baseUrl(query[0], query[1]);
      });
      $("#hunterControlInput").on("keyup", function (e) {
        if (e.which == 13) {
          e.preventDefault();
          e.stopPropagation();

          var query = getHunterParams();

          window.location.href = baseUrl(query[0], query[1]);
        }
      });
    },

    cardsSliderControl: function cardsSliderControl() {
      var slickSettings = {
        slide: ".cs__card",
        autoplay: false,
        accessibility: true,
        rows: 0,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: "#cs__next",
        prevArrow: "#cs__prev",
        variableWidth: true,
        infinite: false,
        responsive: [{
          breakpoint: 1225,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 925,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 595,
          settings: {
            slidesToShow: 1
          }
        }]
      };
      s.$cardsSlider.each(function () {
        if ($(this).hasClass("cards-slider--push")) {
          slickSettings.slidesToShow = 3;

          $(".cards-slider--push").slick(slickSettings);
        } else {
          $(this).slick(slickSettings);
        }
      });
    },

    imageGalleryInit: function imageGalleryInit() {
      s.$imageGallery.each(function () {
        var $this = $(this);
        var $thisNext = $this.find(".ig__next");
        var $thisPrev = $this.find(".ig__prev");
        var fadeVal = $this.hasClass("ig--modal") ? true : false;

        $this.find(".igm__toggle").on("click", function () {
          var targetModalId = $(this).data("modal");
          var $targetModal = $("#" + targetModalId);
          if (!$targetModal.hasClass("open")) {
            $targetModal.addClass("open");
          } else {
            $targetModal.removeClass("open");
          }
        });

        $this.find(".igm__close").on("click", function () {
          $(this).parent().removeClass("open");
        });

        $this.slick({
          slide: ".ig__slide",
          duration: 30,
          fade: fadeVal,
          draggable: true,
          accessibility: true,
          rows: 0,
          nextArrow: $thisNext,
          prevArrow: $thisPrev,
          asNavFor: s.$imageGallery
        });
      });
    },

    testimonialSliderInit: function testimonialSliderInit() {

      s.$testimonialSlider.slick({
        duration: 30,
        draggable: true,
        accessibility: true,
        arrows: false,
        dots: true
      });
    },

    featureSliderControl: function featureSliderControl() {
      $(".fs__images").slick({
        slide: ".fs__image__slide",
        autoplay: false,
        accessibility: true,
        rows: 0,
        draggable: false,
        nextArrow: "#fs__next",
        prevArrow: "#fs__prev",
        asNavFor: ".fs__info",
        infinite: true
      });

      $(".fs__info").slick({
        slide: ".fs__info__slide",
        autoplay: false,
        accessibility: true,
        rows: 0,
        fade: true,
        draggable: false,
        nextArrow: "#fs__next",
        prevArrow: "#fs__prev",
        asNavFor: ".fs__images",
        infinite: true
      });
    },

    spViewerControl: function spViewerControl() {
      s.$spViewer.slick({
        slide: ".sp__card",
        autoplay: false,
        accessibility: true,
        rows: 0,
        draggable: true,
        arrows: false,
        dots: true,
        infinite: true
      });
    },

    hiddenObjAddActive: function hiddenObjAddActive(obj) {
      obj.addClass("active").attr("aria-expanded", "true").attr("aria-hidden", "false");
    },

    hiddenObjRemoveActive: function hiddenObjRemoveActive(obj) {
      obj.removeClass("active").attr("aria-expanded", "false").attr("aria-hidden", "true");
    },

    tabsInit: function tabsInit() {
      s.$tabs.each(function () {
        var $thisTabs = $(this);
        $thisTabs.prepend('<ul class="tp__nav"></ul><div class="tp__content"></div>');
        var $thisTabsNav = $thisTabs.find(".tp__nav");
        var $thisTabsContent = $thisTabs.find(".tp__content");
        $thisTabs.find(".tab__heading").each(function (index) {
          var $linkedContent = $(this).next(".tab__content");
          var firstActive = " active";
          var ariaExpandedState = 'aria-expanded="true"';
          var ariaHiddenState = ' aria-hidden="false"';
          if (!index == 0) {
            firstActive = "";
            ariaExpandedState = 'aria-expanded="false"';
            ariaHiddenState = ' aria-hidden="true"';
          }
          var id = this.innerHTML.toLowerCase().replace(/[\. ,:-]+/g, "-") + "-" + index;
          $(this).replaceWith($('<li class="tab-head"><a href="#' + id + '" class="tp__n__button' + firstActive + '" aria-haspopup="true" ' + ariaExpandedState + ">" + this.innerHTML + "</a></li>"));
          $linkedContent.replaceWith($('<div class="tp__c__panel' + firstActive + '" id="' + id + '" ' + ariaExpandedState + ariaHiddenState + ">" + $linkedContent.html() + "</div>"));
        });
        $thisTabs.find(".tab-head").appendTo($thisTabsNav);
        $thisTabs.find(".tp__c__panel").appendTo($thisTabsContent);
      });

      var $tabsPanelBtns = $(".tp__n__button");

      $tabsPanelBtns.on("click", function (e) {
        var $this = $(this);
        var $parent = $this.closest(".tabs-panel");
        if (!$this.hasClass("active")) {
          $parent.find(".tp__n__button").removeClass("active").attr("aria-expanded", "false");
          $this.addClass("active").attr("aria-expanded", "true");
          var panel = $this.attr("href");
          $parent.find(".tp__c__panel").removeClass("active").attr("aria-expanded", "false").attr("aria-hidden", "true");
          $(panel).addClass("active").attr("aria-expanded", "true").attr("aria-hidden", "false");
        }
        e.preventDefault();
      });
    },

    pageTabsInit: function pageTabsInit() {
      var urlHash = window.location.hash;
      if (urlHash.length) {
        s.$pageTabLinks.removeClass("active").attr("aria-expanded", "false");
        $('a.pt__n__link[href*="' + urlHash + '"]').addClass("active").attr("aria-expanded", "true");
        s.$ptNavToggle.html($('a.pt__n__link[href*="' + urlHash + '"]').children("span").html());
        app.hiddenObjRemoveActive(s.$pageTabTabs);
        app.hiddenObjAddActive($(urlHash));
        app.initStickyProfile();
      }

      s.$pageTabLinks.on("click", function (e) {
        var $this = $(this);
        s.$ptNavToggle.html($this.children("span").html());
        if ($(window).width() < 899) {
          $(".pt__nav").slideUp();
        }
        if (!$this.hasClass("active")) {
          s.$pageTabLinks.removeClass("active").attr("aria-expanded", "false");
          $this.addClass("active").attr("aria-expanded", "true");
          var hashVal = $this.attr("href");
          var pageTabPanel = $(hashVal);
          var pageTabPanelId = hashVal.replace("#", "");
          app.hiddenObjRemoveActive(s.$pageTabTabs);
          app.hiddenObjAddActive(pageTabPanel);
          pageTabPanel.attr("id", "");
          window.location.hash = pageTabPanelId;
          pageTabPanel.attr("id", pageTabPanelId);
          app.initStickyProfile();
        }
        if (s.$testimonialSlider.length) {
          s.$testimonialSlider.slick('setPosition');
        }
        e.preventDefault();
      });

      $(".banner-tab").on("click", function () {
        var href = $(this).attr("href");
        $(".pt__nav").find('a[href*="' + href + '"]').addClass("active");

        $("html, body").animate({
          scrollTop: $(".page-tabs").offset().top - 100
        }, 500);
      });
    },

    mobilePageTabsDropdown: function mobilePageTabsDropdown() {
      s.$ptNavToggle.on("click", function (e) {
        e.preventDefault();
        $(".pt__nav").slideToggle();
      });
    },

    debounce: function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
            args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },

    initStickyProfileSettings: function initStickyProfileSettings() {
      this.$cardSpacing = 20; //space between header and profile card when sticky
      this.$windowPadding = $(".header--main").height(); //header height
      this.$cardHeight = s.$profileCard.height(); //height of profile card
      this.$cardPos = s.$profileCard.parent(".no-collapse").offset().top - 200 - this.$cardSpacing; //card position relative to top of window
      this.$containerHeight = $("#main").height(); //height of #main
      this.$sectionPadding = 80; //padding bottom of related profiles section
      this.$cardTop = s.$profileCard.parent().offset().top; //used to calculate absolute position
    },

    stickyProfile: function stickyProfile(ps) {
      if ($(window).height() > ps.$windowPadding + ps.$cardHeight + ps.$cardSpacing && $(window).width() > 1280) {
        s.$profileCard.parent(".no-collapse").css({
          "min-height": ps.$cardHeight - 200
        });
        if (window.pageYOffset >= ps.$containerHeight - ps.$cardHeight - ps.$cardSpacing - ps.$sectionPadding) {
          s.$profileCard.css({
            position: "absolute",
            top: ps.$containerHeight - ps.$cardTop - ps.$cardHeight + ps.$cardSpacing,
            "margin-top": "0"
          });
        } else if (window.pageYOffset >= ps.$cardPos - ps.$windowPadding) {
          s.$profileCard.removeAttr("style").addClass("stuck");
        } else {
          s.$profileCard.removeAttr("style").removeClass("stuck");
        }
      } else {
        s.$profileCard.removeAttr("style").removeClass("stuck");
      }
    },

    initStickyProfile: function initStickyProfile() {
      if (s.$profileCard.length) {
        var ps = new this.initStickyProfileSettings();

        app.stickyProfile(ps);

        $(window).on("scroll", function () {
          app.stickyProfile(ps);
        });

        var resize = $(window).on("resize", function () {
          app.stickyProfile(ps);
        });

        app.debounce(resize, 400);
      }
    },

    bindUIActions: function bindUIActions() {
      //marign fix for banners - components proceeding
      if ($(".banner--campaign, .filters").length > 0) {
        $(".banner").addClass("collapse--special");
      }

      // form labels stuff
      // $('.sys_cms-form-body input').focus(function() {
      //   $(this).parent().prev('label').css('opacity', '0'); //hide label of clicked item
      // }).blur(function() {
      //
      //   if ($('.sys_cms-form-body input').val() != '') {
      //     var fieldId = $(this).attr('id');
      //     $('label[for="' + fieldId + '"]').css('opacity', '0');
      //   }
      // 	else {
      // 		$(this).parent().prev('label').css('opacity', '1');
      // 	}
      // });
    },

    focusTrap: function (_focusTrap) {
      function focusTrap() {
        return _focusTrap.apply(this, arguments);
      }

      focusTrap.toString = function () {
        return _focusTrap.toString();
      };

      return focusTrap;
    }(function () {
      window.trapList = [];
      s.$focusTraps.each(function (index) {
        window.trapList.push(
        // eslint-disable-next-line no-undef
        focusTrap(s.$focusTraps[index], {
          onDeactivate: function onDeactivate() {
            s.$menuToggle;
          }
        }));
      });
    }),

    bindWindowActions: function bindWindowActions() {
      s.$window.on("load", function () {
        //media query for medium
        if (s.$mediaMatchMed.matches) {
          $(".nav--main > ul > li > a").on("click", false);
          $(".nav--main > ul > li > a").on("blur", function () {
            $(this).parent().children(".second-level").addClass("open");
          });

          $(".skip-to-content").attr("tabindex", 1);
          $("header .logo a").attr("tabindex", 2);
          $(".search-toggle").attr("tabindex", 3);
          $(".menu-toggle").attr("tabindex", 4);

          $(".nav--main > ul > li:first-child > a").on("keydown", function (e) {
            //close mnu when tabbing back
            var x = e.keyCode;
            if (x == 9) {
              if (e.shiftKey) {
                $("nav").removeClass("nav--open");
                $(".menu-toggle").removeClass("toggled");
              } else {
                e.stopPropagation();
              }
            }
          });
          //close menu when tabbed through to the end
          $(".nav__item:last-of-type .second-level .nav__group > ul > li:last-of-type a").on("blur", function () {
            $("nav").removeClass("nav--open");
            $(".menu-toggle").removeClass("toggled");
            $(".menu-toggle").get(0).focus();
          });
          //back btn
          $(".nav__back a").on("keydown", function (e) {
            var x = e.keyCode;
            if (x == 9) {
              if (e.shiftKey) {
                $(this).parents(".third-level").removeClass("open");
              } else {
                e.stopPropagation();
              }
            } else if (x == 13) {
              if (e) {
                $(this).parents(".third-level").removeClass("open");
                //$(this).parents('.third-level').parents('.second-level').addClass('open');
              } else {
                e.stopPropagation();
              }
            }
          });
          $(".nav__back a").on("click", function () {
            $(this).parents(".third-level").removeClass("open");
          });
        }

        $(".nav__item button").on("click", function () {
          if ($(this).hasClass("selected")) {
            $(".selected").removeClass("selected");
            $(".nav__item .open").removeClass("open");
            $(".nav__item .focus").removeClass("focus");
          } else {
            $(".selected").removeClass("selected");
            $(this).addClass("selected").addClass("open");
          }
        });
        $(".second-level a").on("click", function (e) {
          if ($(this).siblings(".nav__sub").length > 0) {
            e.preventDefault();
          }
          if ($(this).siblings().hasClass("open")) {
            $(this).siblings().removeClass("open");
          } else {
            $(this).parent().siblings().children().removeClass("open").removeClass("selected").prev().attr("aria-expanded", false);

            $(this).addClass("selected").next(".third-level").addClass("open");
          }
          if ($(this).next().hasClass("open")) {
            $(this).attr("aria-expanded", true);
          } else {
            $(this).attr("aria-expanded", false);
          }
        });
        $(".third-level .nav__group:last-child li:last-child a").on("blur", function () {
          $(".third-level").removeClass("open");
        });
      });

      // Wizard's line
      $(window).on("load resize", function () {
        if ($(".wzrdry").length > 0) {
          var $thisnav = $(".wzrdry__active").offset().left;

          $(".asd").click($thisnav = $(".wzrdry__active").offset().left);

          $(".wzrdry li a").hover(function () {
            var $left = $(this).children("span").offset().left - $thisnav;
            var $width = $(this).children("span").outerWidth();
            //var $start = 0;
            $(".wzrdry__line").css({
              left: $left,
              width: $width
            });
          }, function () {
            var $initwidth = $(".wzrdry__active").width();
            $(".wzrdry__line").css({
              left: "0",
              width: $initwidth
            });
          });
        }
      });
    },
    autoLogin: function autoLogin() {
      if (window.location.href.indexOf("preview-") === -1) {
        s.$adfs.trigger("click");
      }
    },
    clearADFSHash: function clearADFSHash() {
      if (location.hash.indexOf("id_token") > 0) {
        window.history.pushState(null, document.title, location.origin + location.pathname + location.search);
      }
    }
  };
}(jQuery);

jQuery(document).ready(function () {
  app.init();
});